import * as React from 'react';
require('./style.css');

interface IProps {
	topMenu?: any;
}

class PortalSubNavigation extends React.Component<IProps, {}> {
	public render() {
		const { topMenu } = this.props;

		let content = null;
		if (topMenu) {
			content = <nav className="portalSubNav">{topMenu}</nav>;
		}

		return content;
	}
}
export { PortalSubNavigation };
